export default {
	damageInfo: 'Grading takes into consideration the {count} {link}',
	linkMany: 'scuffed alloys.',
	linkOne: 'scuffed alloy.',
};
